// src/client/widget-loader.js
(function() {
    /**
     * Load the Event Inquiry Widget.
     * @param {string} widgetId - The widget configuration ID.
     * @param {Object} [options] - Optional configuration.
     * @param {string} [options.mode='modal'] - 'modal' or 'inline'.
     * @param {string} [options.containerId] - Container element ID for inline mode.
     * @param {string} [options.triggerText='Inquire About Events'] - Text for the modal trigger button.
     * @param {string} [options.triggerColor] - Background color for the trigger button.
     * @param {boolean} [options.hideTrigger=false] - Hide the floating trigger button (modal still openable via window.openEventInquiryModal).
     */
    function loadEventInquiryWidget(widgetId, options) {
        if (window.eagleEyeEventInquiryWidgetInitialized === true) {
            console.error('Event Inquiry widget already initialized. Please only inject the initialization script once.');
            return;
        }

        var opts = options || {};
        var mode = opts.mode || 'modal';
        var containerId = opts.containerId || 'event-inquiry-widget';
        var triggerText = opts.triggerText || 'Inquire About Events';
        var triggerColor = opts.triggerColor || '#10B981';
        var hideTrigger = opts.hideTrigger || false;

        var baseUrl = EAGLEEYE_WIDGET_BASE_URL;

        if (mode === 'modal') {
            createModalStructure(widgetId, baseUrl, triggerText, triggerColor, hideTrigger);
        } else {
            createInlineStructure(widgetId, baseUrl, containerId);
        }

        window.eagleEyeEventInquiryWidgetInitialized = true;
    }

    function createModalStructure(widgetId, baseUrl, triggerText, triggerColor, hideTrigger) {
        // Inject animations + scrollbar CSS
        var style = document.createElement('style');
        style.textContent = [
            '@keyframes eeSlideUp { from { opacity:0; transform:translateY(20px) scale(0.98); } to { opacity:1; transform:translateY(0) scale(1); } }',
            '@keyframes eeFadeIn { from { opacity:0; } to { opacity:1; } }',
            '#ee-inquiry-overlay { animation: eeFadeIn 0.2s ease-out; }',
            '#ee-inquiry-modal { animation: eeSlideUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1); }',
            '#ee-inquiry-modal::-webkit-scrollbar { width: 6px; }',
            '#ee-inquiry-modal::-webkit-scrollbar-track { background: transparent; }',
            '#ee-inquiry-modal::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 3px; }',
            '#ee-inquiry-modal::-webkit-scrollbar-thumb:hover { background: #9ca3af; }',
            '#ee-inquiry-modal { scrollbar-width: thin; scrollbar-color: #d1d5db transparent; }',
        ].join('\n');
        document.head.appendChild(style);

        // Create floating trigger button
        var triggerBtn = document.createElement('button');
        triggerBtn.id = 'ee-inquiry-trigger';
        triggerBtn.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" style="display:inline-block;vertical-align:middle;margin-right:8px;margin-top:-1px;"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>' +
            '<span>' + triggerText + '</span>';
        triggerBtn.style.cssText =
            'position:fixed;bottom:24px;right:24px;z-index:99998;' +
            'padding:14px 26px;border:none;border-radius:50px;cursor:pointer;' +
            'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;' +
            'font-size:15px;font-weight:600;color:#fff;line-height:1;' +
            'background:' + triggerColor + ';' +
            'box-shadow:0 4px 16px rgba(0,0,0,0.18), 0 1px 3px rgba(0,0,0,0.1);' +
            'transition:all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);';
        triggerBtn.onmouseenter = function() {
            triggerBtn.style.transform = 'translateY(-3px) scale(1.03)';
            triggerBtn.style.boxShadow = '0 8px 24px rgba(0,0,0,0.22), 0 2px 6px rgba(0,0,0,0.1)';
        };
        triggerBtn.onmouseleave = function() {
            triggerBtn.style.transform = 'translateY(0) scale(1)';
            triggerBtn.style.boxShadow = '0 4px 16px rgba(0,0,0,0.18), 0 1px 3px rgba(0,0,0,0.1)';
        };
        if (hideTrigger) {
            triggerBtn.style.display = 'none';
        }
        document.body.appendChild(triggerBtn);

        // Create modal overlay
        var overlay = document.createElement('div');
        overlay.id = 'ee-inquiry-overlay';
        overlay.style.cssText =
            'display:none;position:fixed;top:0;left:0;right:0;bottom:0;z-index:99999;' +
            'background:rgba(0,0,0,0.45);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);' +
            'justify-content:center;align-items:flex-start;padding:24px;overflow-y:auto;';

        // Modal container — transparent shell; the widget inside provides its own card + bg
        var modalContainer = document.createElement('div');
        modalContainer.id = 'ee-inquiry-modal';
        modalContainer.style.cssText =
            'background:transparent;border-radius:20px;max-width:620px;width:100%;' +
            'position:relative;margin:auto;overflow:hidden;' +
            'box-shadow:0 25px 60px rgba(0,0,0,0.2), 0 8px 20px rgba(0,0,0,0.1);';

        // Close button
        var closeBtn = document.createElement('button');
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.innerHTML = '<svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" style="display:block;"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>';
        closeBtn.style.cssText =
            'position:absolute;top:16px;right:16px;z-index:10;' +
            'background:rgba(255,255,255,0.85);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);' +
            'border:1px solid rgba(0,0,0,0.08);' +
            'font-size:18px;color:#6b7280;cursor:pointer;' +
            'width:36px;height:36px;display:flex;align-items:center;justify-content:center;' +
            'border-radius:50%;transition:all 0.2s;padding:0;line-height:1;';
        closeBtn.onmouseenter = function() {
            closeBtn.style.background = '#fff';
            closeBtn.style.color = '#111827';
            closeBtn.style.boxShadow = '0 2px 8px rgba(0,0,0,0.12)';
        };
        closeBtn.onmouseleave = function() {
            closeBtn.style.background = 'rgba(255,255,255,0.85)';
            closeBtn.style.color = '#6b7280';
            closeBtn.style.boxShadow = 'none';
        };
        closeBtn.onclick = function() { closeModal(); };
        modalContainer.appendChild(closeBtn);

        // Widget content container
        var widgetContent = document.createElement('div');
        widgetContent.id = 'ee-inquiry-widget-content';
        modalContainer.appendChild(widgetContent);

        overlay.appendChild(modalContainer);
        overlay.onclick = function(e) {
            if (e.target === overlay) closeModal();
        };
        document.body.appendChild(overlay);

        // Trigger opens modal
        triggerBtn.onclick = function() { openModal(); };

        var widgetLoaded = false;

        function openModal() {
            overlay.style.display = 'flex';
            document.body.style.overflow = 'hidden';
            // Hide trigger when modal is open
            triggerBtn.style.display = 'none';
            if (!widgetLoaded) {
                loadWidgetContent(widgetId, baseUrl, 'ee-inquiry-widget-content');
                widgetLoaded = true;
            }
        }

        function closeModal() {
            overlay.style.display = 'none';
            document.body.style.overflow = '';
            // Restore trigger (only if not permanently hidden)
            if (!hideTrigger) {
                triggerBtn.style.display = '';
            }
        }

        // Close on Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && overlay.style.display === 'flex') {
                closeModal();
            }
        });

        // Expose open/close functions globally for programmatic access
        window.openEventInquiryModal = openModal;
        window.closeEventInquiryModal = closeModal;
    }

    function createInlineStructure(widgetId, baseUrl, containerId) {
        var targetContainer = document.getElementById(containerId);
        if (!targetContainer) {
            console.error('Event Inquiry Widget: Container element #' + containerId + ' not found.');
            return;
        }
        loadWidgetContent(widgetId, baseUrl, containerId);
    }

    function loadWidgetContent(widgetId, baseUrl, targetContainerId) {
        fetch(baseUrl + '/event-inquiry-widget?widgetId=' + encodeURIComponent(widgetId))
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('Widget configuration not found (' + response.status + ')');
                }
                return response.text();
            })
            .then(function(htmlContent) {
                var container = document.createElement('div');
                container.innerHTML = htmlContent;

                // Extract and execute scripts
                var scripts = container.querySelectorAll('script');
                scripts.forEach(function(script) {
                    if (script.src) {
                        var newScript = document.createElement('script');
                        newScript.src = script.src;
                        newScript.crossOrigin = script.crossOrigin || null;
                        document.head.appendChild(newScript);
                    } else {
                        try {
                            eval(script.textContent);
                        } catch (e) {
                            console.error('Error executing widget script:', e);
                        }
                    }
                    script.parentNode.removeChild(script);
                });

                // Clear any loading placeholder and append widget HTML
                var targetContainer = document.getElementById(targetContainerId);
                if (targetContainer) {
                    targetContainer.innerHTML = '';
                    while (container.firstChild) {
                        targetContainer.appendChild(container.firstChild);
                    }
                }

                // Load main widget bundle
                loadMainBundle(baseUrl);
            })
            .catch(function(error) {
                console.error('Error loading event inquiry widget:', error);
                showWidgetError(error.message, targetContainerId);
            });
    }

    function loadMainBundle(baseUrl) {
        var script = document.createElement('script');
        var timestamp = new Date().getTime();
        script.src = baseUrl + '/public/js/main.bundle.js?v=' + timestamp;
        script.onload = function() {
            console.log('Event Inquiry widget script loaded');
            if (window.initializeEventInquiryWidget) {
                window.initializeEventInquiryWidget();
            }
        };
        script.onerror = function() {
            console.error('Failed to load event inquiry widget script');
        };
        document.body.appendChild(script);
    }

    function showWidgetError(message, containerId) {
        var targetContainer = document.getElementById(containerId);
        if (targetContainer) {
            targetContainer.innerHTML =
                '<div style="padding:48px 32px;text-align:center;background:#ffffff;border-radius:16px;">' +
                '<div style="width:56px;height:56px;background:#fef2f2;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;">' +
                '<svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="#ef4444" style="display:block;"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"/></svg>' +
                '</div>' +
                '<h3 style="font-size:1.125rem;font-weight:600;color:#111827;margin:0 0 8px;">Unable to Load Form</h3>' +
                '<p style="font-size:0.875rem;color:#6b7280;margin:0 0 24px;line-height:1.5;">' + message + '</p>' +
                '<button onclick="location.reload()" style="padding:10px 24px;background:#ef4444;color:white;border:none;border-radius:8px;cursor:pointer;font-size:0.875rem;font-weight:500;font-family:inherit;transition:background 0.2s;" onmouseenter="this.style.background=\'#dc2626\'" onmouseleave="this.style.background=\'#ef4444\'">Reload Page</button>' +
                '</div>';
        }
    }

    // Expose globally
    window.loadEventInquiryWidget = loadEventInquiryWidget;
})();
